var React = require('react');

function ChartViewSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5.994 11.994a6 6 0 01-5.54-3.7 6.056 6.056 0 01-.34-3.47 5.99 5.99 0 014.71-4.71 6.064 6.064 0 013.47.34 5.931 5.931 0 012.69 2.21 6 6 0 01-4.99 9.33zm0-10a3.993 3.993 0 00-2.22.67 3.93 3.93 0 00-1.47 1.8 4.006 4.006 0 00.86 4.36 3.911 3.911 0 002.05 1.09 3.969 3.969 0 002.31-.23 4.046 4.046 0 001.8-1.47 4 4 0 00-3.33-6.22zm0 6a2 2 0 10-2-2 2.006 2.006 0 002 2z","key":0}),React.createElement("path",{"fill":"none","d":"M0 0h12v12H0z","key":1})]);
}

ChartViewSmall.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","className":"css-1s665wz"};

module.exports = ChartViewSmall;

ChartViewSmall.default = ChartViewSmall;
